import React from 'react'
import { notify, Notifications } from 'sb-notify-me'
import notifyHelper from 'sb-notify-me/helper'
import { Portal } from 'react-portal'
import { constants, mixpanel } from 'common/helpers'

import Product from 'components/notifications/Fragrance/Fragrance'
import BeautyBag from 'components/notifications/BeautyBag/BeautyBag'
import OutOfStockSubscription from 'components/notifications/OutOfStockSubscription/OutOfStockSubscription'
import SeveralQueueItems from 'components/notifications/SeveralQueueItems/SeveralQueueItems'
import ApplyDiscountSuccess from 'components/notifications/ApplyDiscountSuccess/ApplyDiscountSuccess'


const templates = {
  /**
   *
   * @param props {object}
   * @param props.item {object}
   */
  perfumeItem: (props) => <Product {...props} />,
  beautyBag: (props) => <BeautyBag {...props} />,
  OutOfStockSubscription: (props) => <OutOfStockSubscription {...props} />,
  severalQueueItems: (props) => <SeveralQueueItems {...props} />,
  applyDiscountSuccess: (props) => <ApplyDiscountSuccess {...props} />,
}

notifyHelper.subscribe((tplName, props) => {
  notify({
    content: templates[tplName](props),
    onUserClick: () => {
      mixpanel.track(constants.analyticsEvents.notificationClick, {
        template: tplName,
      })
    },
    onUserClose: () => {
      mixpanel.track(constants.analyticsEvents.notificationCloseClick, {
        template: tplName,
      })
    },
  })
})


const NotificationConductor = () => (
  <Portal>
    <Notifications />
  </Portal>
)


export default NotificationConductor
